interface BucketCardProps {
  count: number;
  label: string;
  total: number;
  color: string;
}

export function BucketCard({ count, label, total, color }: BucketCardProps) {
  const percentage = total > 0 ? Math.round((count / total) * 100) : 0;

  return (
    <div className="text-center">
      <div className={`text-3xl font-bold ${color}`}>{count}</div>
      <div className="text-sm text-gray-600">{label}</div>
      <div className="text-xs text-gray-500">{percentage}%</div>
    </div>
  );
}
